import React, { useEffect, useState } from 'react';
import { 
  Box, FormControl, RadioGroup, FormControlLabel, Radio, 
  InputLabel, Select, MenuItem, Divider 
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { StyledPanelHeader } from '../../Common/Layout/PanelHeader';
import BasePanel from '../../Common/Layout/BasePanel';
import { BasePanelBox } from '../../Common/Layout/BasePanelBox';
import { getStyles } from './styles';
import { UploadType } from './ManageContests';
import contestService from '../../../services/ContestService';
import DownloadTemplates from './DownloadTemplates';
import { Contest } from '@beable/roster-backend-client-v1';

interface ManageContestsPanelProps {
  uploadType: UploadType;
  onUploadTypeChange(uploadType: UploadType): void;
  onContestChange(contestId: string): void;
}

export default function ManageContestsPanel({ uploadType, onUploadTypeChange, onContestChange }: ManageContestsPanelProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [contests, setContests] = useState<Contest[]>([]);
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    const fetchContests = async () => {
        const data = await contestService.getContests();
        if (data) setContests(data);
        else setContests([]);
    };

    fetchContests();
  }, []);

  const handleContestChange = (event: any) => {
    setSelectedValue(event.target.value);
    onContestChange(event.target.value);
  }

  return (
    <BasePanel>
      <BasePanelBox>
        <StyledPanelHeader header='Manage Contests' />
        <Box sx={{
          p: 4
        }}>
          <Box sx={styles.mb1}>

            <FormControl variant="standard" sx={styles.pFormControl}>
              <RadioGroup
                aria-label="provision by"
                value={uploadType}
                onChange={(e) => onUploadTypeChange(e.target.value as UploadType)}
              >
                <FormControlLabel
                  value={UploadType.New}
                  control={<Radio />}
                  label='Upload New Contest'
                />
                <FormControlLabel
                  value={UploadType.Update}
                  control={<Radio />}
                  label='Update Existing Contest'
                />
              </RadioGroup>
            </FormControl>

            { uploadType === UploadType.Update && (
            <FormControl sx={styles.contestSelector} variant={'outlined'}>
              <InputLabel htmlFor='contestId'>{!contests.length ? "No Contests Found" : "Select Contest"}</InputLabel>
              <Select
                variant="standard"
                value={selectedValue}
                onChange={handleContestChange}
                inputProps={{
                  name: 'contestId',
                  id: 'contestId',
                  role: 'option'
                }}>
              { contests.length &&
                contests.map((contest: Contest) => (
                  <MenuItem key={contest.id} value={contest.id} role='option'>
                      <em>{contest.contestName}</em>
                  </MenuItem>
                ))
              }
              </Select>
            </FormControl>
            )}
          </Box>

          <Divider/>
          <DownloadTemplates/>

        </Box>
      </BasePanelBox>
    </BasePanel>
  );
}
